<template>
  <q-page padding>
    <PageHeader
      title="Central de Downloads"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <tabela></tabela>
  </q-page>
</template>

<script>
import PageHeader from "../../../components/PageHeader.vue";
import Tabela from "../components/TableDownloads.vue";
export default {
  components: {
    Tabela,
    PageHeader,
  },
  setup() {
    return {};
  },
};
</script>
